import React, { Component } from 'react';
import Modal from '../UI/Modal';
import MediaItem from '../UI/MediaItem';
import { destroy as destroyMedia, setMediaItemForDelete } from '../../store/actions/media';
import { connect } from 'react-redux';
import { classNamesPrefixed } from '../../../helpers/CoreHelpers';
import BtnPrimary from "../UI/BtnPrimary";
import BtnSecondary from "../UI/BtnSecondary";
import { MediaContext } from '../../../contexts/MediaContext';

class MediaConfirmDelete extends Component {
    static contextType = MediaContext;

    componentDidMount() {
        document.addEventListener("keyup", this.handleKeyUp.bind(this));
    }

    componentWillUnmount() {
        document.removeEventListener("keyup", this.handleKeyUp.bind(this));
    }

    handleKeyUp(event) {
        if (this.props.media && this.props.media.deleteItemId) {
            if (event.key === 'y' || event.key === 'Y' || event.key === 'Enter') {
                this.deleteMediaItem();
            }

            if (event.key === 'n' || event.key === 'N' || event.key === 'Escape') {
                this.cancelDeleteMediaItem();
            }
        }
    }

    getMediaItem(id) {
        let x = null;
        const { media } = this.props;

        id = parseInt(id, 10);

        for (x in media.items) {
            if (media.items[x].id === id) {
                return media.items[x];
            }
        }

        return null;
    }

    cancelDeleteMediaItem(event) {
        if (event) {
            event.preventDefault();
        }
        this.props.setMediaItemForDelete(null);
    }

    deleteMediaItem(event) {
        if (event) {
            event.preventDefault();
        }
        if (this.props.media && this.props.media.deleteItemId) {
            this.props.destroyMedia(this.props.media.deleteItemId);
        }
    }

    render() {
        const { media } = this.props;
        let deleteItemId = null;

        if (media && media.deleteItemId) {
            deleteItemId = media.deleteItemId;
        }
        let showModal = false;
        if (deleteItemId) {
            showModal = true;
        }

        const { isMobile } = this.context;

        return (
            <Modal
                title={"Are you sure you want to delete media item?"}
                showModal={showModal}
                icon={"trash-alt"}
                onClose={(event) => this.cancelDeleteMediaItem()}
                noScroll={true}
                modalFooter={
                    <div
                        className={classNamesPrefixed({
                            'form-actions': true
                        })}
                    >
                        <BtnSecondary
                            small
                            danger
                            icon="trash-alt"
                            value={deleteItemId}
                            onClick={(event) => this.deleteMediaItem(event)}
                            help="Press 'y' to confirm">{isMobile ? 'Yes' : 'Yes delete!'}</BtnSecondary>
                        <BtnPrimary
                            small
                            icon="minus-circle"
                            value={deleteItemId}
                            onClick={(event) => this.cancelDeleteMediaItem(event)}
                            help="Press 'n' to cancel">{isMobile ? 'No' : `No don't`}</BtnPrimary>
                    </div>
                }
            >
                <div
                    className={classNamesPrefixed({
                        'confirm-delete': true
                    })}
                >
                    <div
                        className={classNamesPrefixed({
                            'confirm-delete-content': true
                        })}
                    >
                        <p>
                            You are about to delete an item, this action is irreversible!
                        </p>
                        <MediaItem item={this.getMediaItem(deleteItemId)} clickableThumbnail={true} />
                    </div>

                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        workspace: state.workspace,
        media: state.media,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        destroyMedia: (id) => dispatch(destroyMedia(id)),
        setMediaItemForDelete: () => dispatch(setMediaItemForDelete())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MediaConfirmDelete)


// WEBPACK FOOTER //
// ./src/core/admin/components/Forms/MediaConfirmDelete.js